import analyticDataStore, {
  IBaseAnalyticsCombined,
} from "@/store/analyticsDataStore";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import DateRangeAndSlider from "../ClientSummaryReport/DateRangeAndSlider";
import CurrencyAndDV01Filters from "./CurrencyAndDV01Filters";
import MainTableContainer from "./MainTableContainer";
import WeightedSliders from "./WeightedSliders";

export interface IBrokerRankSliderValues {
  DVO1Percent: number;
  TimePercent: number;
  // AxePercent: number;
  // ShownPercent: number;
  SpreadPercent: number;
  HitRatePercent: number;
}
export interface IBaseFilterBrokerRank extends IBrokerRankSliderValues {
  range: number[];
  selectedCurrencies: string[];
  selectedBuckets: [];
  DV01BucketsKeys: string[];
}

export const baseFilterBrokerRank: IBaseFilterBrokerRank = {
  range: [],
  selectedCurrencies: [],
  selectedBuckets: [],
  DV01BucketsKeys: [],
  DVO1Percent: 50,
  TimePercent: 50,
  // AxePercent: 50,
  // ShownPercent: 50,
  SpreadPercent: 50,
  HitRatePercent: 50,
};

const BrokerRankIndex = () => {
  const { theme } = useTheme();
  const analyticsZustand = analyticDataStore((state) => state.analyticData);

  const [data, setData] = useState<IBaseAnalyticsCombined[]>(analyticsZustand);
  useEffect(() => {
    setData(analyticsZustand);
  }, [analyticsZustand]);
  const [dataFilters, setDataFilters] =
    useState<IBaseFilterBrokerRank>(baseFilterBrokerRank);

  const isSecondary = false;

  return (
    <div className="w-fill flex h-full p-1">
      <div className="flex h-full w-full gap-3">
        {/* SIDEBAR */}
        <div className="flex h-full min-w-[230px] flex-col gap-3">
          <div
            className={`${
              theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"
            }  flex h-full w-full flex-col p-2`}
          >
            {/* DATE RANGE = auto height */}
            <div className="flex h-fit w-full">
              <div className="w-full">
                <DateRangeAndSlider
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                  isSecondary={isSecondary}
                />
              </div>
            </div>

            {/* SIDEBAR BELOW = fills remaining height */}
            <div className="flex h-[calc(100%-100px)]  w-full flex-1 flex-col gap-2">
              <div
                className={`flex h-full max-h-[200px] flex-[2] flex-col overflow-auto p-1  ${
                  theme == "dark"
                    ? "agChartCubeBorderDark"
                    : "agChartCubeBorder"
                }`}
              >
                <WeightedSliders
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                />
              </div>
              <div
                className={`flex h-full flex-[1] flex-col overflow-auto p-1 ${
                  theme == "dark"
                    ? "agChartCubeBorderDark"
                    : "agChartCubeBorder"
                }`}
              >
                <CurrencyAndDV01Filters
                  data={data}
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                />
              </div>
            </div>
          </div>
        </div>
        {/* MAIN CONTENT */}
        <div className="flex h-full w-full">
          <MainTableContainer data={data} dataFilters={dataFilters} />
        </div>
      </div>
    </div>
  );
};

export default BrokerRankIndex;
